import { render, staticRenderFns } from "./aboutDuty.vue?vue&type=template&id=0d27e44e&scoped=true&"
import script from "./aboutDuty.vue?vue&type=script&lang=js&"
export * from "./aboutDuty.vue?vue&type=script&lang=js&"
import style0 from "./aboutDuty.vue?vue&type=style&index=0&id=0d27e44e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d27e44e",
  null
  
)

export default component.exports